import { render, staticRenderFns } from "./style2.vue?vue&type=template&id=842b7b38&scoped=true&"
import script from "./style2.vue?vue&type=script&lang=js&"
export * from "./style2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842b7b38",
  null
  
)

export default component.exports